module.exports = __webpack_public_path__ + "094d781920f9810d11682abf2168be09.png";